// The one query cache for the app. If any API call finds the session gone (signed out elsewhere, expired),
// the app goes back to the sign-in page. The sign-in check itself (meta.signInCheck) leaves that to the router.
import { QueryCache, QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (error instanceof ApiError && error.status === 401 && !query.meta?.signInCheck) {
        window.location.assign('/signin');
      }
    },
  }),
  defaultOptions: { queries: { staleTime: 60_000, retry: 1, refetchOnWindowFocus: false } },
});
